import Input from "../../material/input/Input";

const AddressRegistration = ({
  postCode,
  setPostCode,
  disablePostCode,
  disablePhone,
  phoneNumber,
  setPhoneNumber,
  email,
  setEmail,
  disableEmail,
  regex,
}) => {
  return (
    <div className="max-w-[1000px] mx-auto mt-8">
      <div className="text-[16px] leading-6 text-[#2E2E2E] font-medium mb-5">
        ที่อยู่ปัจจุบัน
      </div>

      <div className="grid grid-cols-2 md:grid-cols-1 gap-4">
        <Input
          disabled={disablePostCode}
          regex={regex.postCode()}
          label="รหัสไปรษณีย์"
          placeholder="รหัสไปรษณีย์"
          value={postCode}
          setValue={setPostCode}
        />

        <div className="block md:hidden" />

        <Input
          disabled={disablePhone}
          regex={regex.phoneNumber()}
          label="เบอร์โทร"
          placeholder="เบอร์โทร"
          value={phoneNumber}
          setValue={setPhoneNumber}
        />

        <Input
          disabled={disableEmail}
          label="Email (ถ้ามี)"
          placeholder="Email"
          value={email}
          setValue={setEmail}
        />
      </div>
    </div>
  );
};

export default AddressRegistration;
